<!-- Copy Order Popup -->
<div class="ModernPopupOverlay" *ngIf="ShowOrderCopy" (click)="ShowOrderCopy = false; CurrentOrder = null;">
  <div class="ModernPopup small" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons" style="color: #667eea;">content_copy</i>
        <span>{{ 'CopyOfferRequestTitle' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="ShowOrderCopy = false; CurrentOrder = null;">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody">
      <p class="ModernPopupDescription" style="text-align: center;">{{ 'CopyOfferRequestDescription' | translate }}</p>
    </div>
    <div class="ModernPopupFooter">
      <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="ShowOrderCopy = false; CurrentOrder = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button class="ModernButton primary" [disabled]="this.parent.loading" (click)="ShowOrderCopy = false;CopyOrder(CurrentOrder);">
        <i class="material-icons">content_copy</i>
        <span>{{ 'AcceptAndContinueCopy' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- Cancel Order Popup -->
<div class="ModernPopupOverlay" *ngIf="ShowOrderCancelation" (click)="ShowOrderCancelation = false; CurrentOrder = null;">
  <div class="ModernPopup small" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons" style="color: #fd4f57;">warning</i>
        <span>{{ 'CancelQuestion' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="ShowOrderCancelation = false; CurrentOrder = null;">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody">
      <p class="ModernPopupDescription" style="text-align: center;">{{ 'CancelQuestionDescription' | translate }}</p>
    </div>
    <div class="ModernPopupFooter">
      <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="ShowOrderCancelation = false; CurrentOrder = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button class="ModernButton danger" [disabled]="this.parent.loading" (click)="ShowOrderCancelation = false;CancelOrder(CurrentOrder);">
        <i class="material-icons">close</i>
        <span>{{ 'YesCancel' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<div class="overlay" *ngIf="ShowEditContainer;"></div>

<!-- Shipment Request Popup (Modern Design) -->
<div class="ModernPopupOverlay" *ngIf="this.ShowShipmentRequestPopup == true;" (click)="this.ShowShipmentRequestPopup = false;">
  <div class="ModernPopup large" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons">local_shipping</i>
        <span>{{'SendShipmentRequestPreparation' | translate}}</span>
      </div>
      <button class="ModernPopupClose" (click)="this.ShowShipmentRequestPopup = false;">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody">
    <div class="ShipmentRequestDropdownsContainer" *ngIf="this.parent.loading != true;">
      <!-- Shipping Responsibility Dropdown (Popup) -->
      <div class="ShipmentRequestDropdownWrapper">
        <div class="CustomDropdownContainer">
          <div class="SendEmailOverlayTransparent" *ngIf="showShippingResponsabilityResultsPopup" (click)="showShippingResponsabilityResultsPopup = false"></div>

          <div class="CustomDropdownBar" (click)="showShippingResponsabilityResultsPopup = !showShippingResponsabilityResultsPopup">
            <span class="dropdown-label">{{ 'ShippingResponsability' | translate }}</span>
            <i class="material-icons dropdown-icon-left">local_shipping</i>
            <i class="material-icons send-email-icon" [style.color]="this.ShippingDetails?.ShippingResponsability?.ID != null ? '#4caf50' : '#f44336'">
              {{ this.ShippingDetails?.ShippingResponsability?.ID != null ? 'check_circle' : 'cancel' }}
            </i>
            <input type="text" class="CustomDropdownInput" [value]="this.ShippingDetails?.ShippingResponsability?.Name || ''" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>

          <div class="CustomDropdownResults" *ngIf="showShippingResponsabilityResultsPopup">
            <div class="CustomDropdownResult" *ngFor="let s of this.ShippingResponsabilities" (click)="selectShippingResponsabilityPopup(s)">
              <div class="CustomDropdownResultMain">
                <i class="material-icons" [style.color]="this.ShippingDetails?.ShippingResponsability?.ID === s.ID ? '#4caf50' : '#f44336'">
                  {{ this.ShippingDetails?.ShippingResponsability?.ID === s.ID ? 'check_circle' : 'cancel' }}
                </i>
                <span class="CustomDropdownResultText">{{s.Name}} ({{s.Description}})</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Shipping Company Dropdown (Popup) -->
      <div class="ShipmentRequestDropdownWrapper" [style.opacity]="this.ShippingDetails?.ShippingResponsability?.ID === 0 ? '0.4' : '1'" [style.pointer-events]="this.ShippingDetails?.ShippingResponsability?.ID === 0 ? 'none' : 'auto'">
        <div class="CustomDropdownContainer">
          <div class="SendEmailOverlayTransparent" *ngIf="showShippingCompanyResultsPopup" (click)="showShippingCompanyResultsPopup = false"></div>

          <div class="CustomDropdownBar" [class.disabled]="this.parent.loading || this.ShippingDetails?.ShippingResponsability?.ID == null || this.ShippingDetails?.ShippingResponsability?.ID === 0" (click)="!this.parent.loading && this.ShippingDetails?.ShippingResponsability?.ID != null && this.ShippingDetails?.ShippingResponsability?.ID !== 0 && (showShippingCompanyResultsPopup = !showShippingCompanyResultsPopup)">
            <span class="dropdown-label">{{ 'ShippingCompany' | translate }}</span>
            <img *ngIf="this.ShippingDetails?.ShippingCompany?.ImagePath" [src]="this.parent.BackendServiceUrl + this.ShippingDetails?.ShippingCompany?.ImagePath" class="shipping-company-logo-selected" />
            <i *ngIf="!this.ShippingDetails?.ShippingCompany?.ImagePath" class="material-icons dropdown-icon-left">business</i>
            <i class="material-icons send-email-icon" [style.color]="this.ShippingDetails?.ShippingCompany?.ID ? '#4caf50' : '#f44336'">
              {{ this.ShippingDetails?.ShippingCompany?.ID ? 'check_circle' : 'cancel' }}
            </i>
            <input type="text" class="CustomDropdownInput" [value]="this.ShippingDetails?.ShippingCompany?.Name || ''" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>

          <div class="CustomDropdownResults" *ngIf="showShippingCompanyResultsPopup && !this.parent.loading && this.ShippingDetails?.ShippingResponsability?.ID != null">
            <div class="CustomDropdownResult" *ngFor="let s of this.ShippingCompanies" (click)="selectShippingCompanyPopup(s)">
              <div class="CustomDropdownResultMain">
                <i class="material-icons" [style.color]="this.ShippingDetails?.ShippingCompany?.ID === s.ID ? '#4caf50' : '#f44336'">
                  {{ this.ShippingDetails?.ShippingCompany?.ID === s.ID ? 'check_circle' : 'cancel' }}
                </i>
                <img *ngIf="s.ImagePath" [src]="this.parent.BackendServiceUrl + s.ImagePath" class="shipping-company-logo-dropdown" />
                <span class="CustomDropdownResultText">{{s.Name}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Shipping Service Type Dropdown (Popup) -->
      <div class="ShipmentRequestDropdownWrapper" [style.opacity]="this.ShippingDetails?.ShippingResponsability?.ID === 0 ? '0.4' : '1'" [style.pointer-events]="this.ShippingDetails?.ShippingResponsability?.ID === 0 ? 'none' : 'auto'">
        <div class="CustomDropdownContainer">
          <div class="SendEmailOverlayTransparent" *ngIf="showShippingServiceTypeResultsPopup" (click)="showShippingServiceTypeResultsPopup = false"></div>

          <div class="CustomDropdownBar" [class.disabled]="this.parent.loading || this.ShippingDetails?.ShippingResponsability?.ID == null || this.ShippingDetails?.ShippingResponsability?.ID === 0" (click)="!this.parent.loading && this.ShippingDetails?.ShippingResponsability?.ID != null && this.ShippingDetails?.ShippingResponsability?.ID !== 0 && (showShippingServiceTypeResultsPopup = !showShippingServiceTypeResultsPopup)">
            <span class="dropdown-label">{{ 'ShippingServiceType' | translate }}</span>
            <i class="material-icons dropdown-icon-left">flight_takeoff</i>
            <i class="material-icons send-email-icon" [style.color]="this.ShippingDetails?.ShippingServiceType?.ID ? '#4caf50' : '#f44336'">
              {{ this.ShippingDetails?.ShippingServiceType?.ID ? 'check_circle' : 'cancel' }}
            </i>
            <input type="text" class="CustomDropdownInput" [value]="this.ShippingDetails?.ShippingServiceType?.Name || ''" readonly />
            <i class="material-icons dropdown-icon">arrow_drop_down</i>
          </div>

          <div class="CustomDropdownResults" *ngIf="showShippingServiceTypeResultsPopup && !this.parent.loading && this.ShippingDetails?.ShippingResponsability?.ID != null">
            <div class="CustomDropdownResult" *ngFor="let s of this.ShippingServiceTypes" (click)="selectShippingServiceTypePopup(s)">
              <div class="CustomDropdownResultMain">
                <i class="material-icons" [style.color]="this.ShippingDetails?.ShippingServiceType?.ID === s.ID ? '#4caf50' : '#f44336'">
                  {{ this.ShippingDetails?.ShippingServiceType?.ID === s.ID ? 'check_circle' : 'cancel' }}
                </i>
                <span class="CustomDropdownResultText">{{s.Name}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Shipping Cost Display -->
    <div class="ShippingCostDisplay" *ngIf="getSelectedShippingCost() && this.ShippingDetails?.ShippingResponsability?.ID !== 0" style="width: 95%; margin-left: 2.5%; margin-top: 15px; margin-bottom: 15px; padding: 10px 14px; background: #f8f9fa; border: 1px solid #e0e0e0; border-radius: 6px;">
      <div style="display: flex; align-items: center; justify-content: space-between;">
        <div style="display: flex; align-items: center; gap: 8px;">
          <i class="material-icons" style="color: #667eea; font-size: 20px;">local_atm</i>
          <div>
            <p style="margin: 0; color: #666; font-size: 10px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.5px;">{{ 'EstimatedShippingCost' | translate }}</p>
            <p style="margin: 0; color: #333; font-size: 18px; font-weight: 600; margin-top: 2px;">{{getSelectedShippingCost().Price?.UIUnitPrice | number:'1.2-2'}} {{getCurrencySymbol(getSelectedShippingCost().Price?.Currency?.ID)}}</p>
          </div>
        </div>
        <div style="display: flex; align-items: center; gap: 4px;">
          <i class="material-icons" style="color: #0082e6; font-size: 16px;" *ngIf="getSelectedShippingCost().ShippingServiceType?.ID == -1">local_shipping</i>
          <i class="material-icons" style="color: #32aa3a; font-size: 16px;" *ngIf="getSelectedShippingCost().ShippingServiceType?.ID == 1">flight_takeoff</i>
          <span style="color: #666; font-size: 10px; font-weight: 500;">{{getSelectedShippingCost().ShippingServiceType?.Name}}</span>
        </div>
      </div>
      <p style="margin: 6px 0 0 0; font-size: 10px; font-style: italic; color: #f60; line-height: 1.4;">
        {{'ShippingCostEstimationDisclaimer' | translate}}
      </p>
    </div>

    <div class="EmailReceipientsContainer" *ngIf="this.ShippingDetails?.ShippingResponsability?.RequiresInsurance != null;">
      <p>{{'ProductsInsurance' | translate}}</p>
      <div class="auto-save-toggle-container" matTooltip="{{ 'RequestProductsInsuranceDescription' | translate}}" matTooltipClass='neutral-tool-tip'>
        <label class="auto-save-toggle" [class.disabled]="ShippingDetails.ShippingResponsability?.RequiresInsurance">
          <input type="checkbox" [disabled]="ShippingDetails.ShippingResponsability?.RequiresInsurance" [(ngModel)]="this.ShippingDetails.ShippingResponsability.Insurance">
          <span class="toggle-slider"></span>
        </label>
        <span class="auto-save-label">{{'RequestProductsInsurance' | translate}}</span>
      </div>
      <div class="EmailReceipientsContainerInfo">
        {{ 'RequestProductsInsuranceDescription2' | translate}}
      </div>
    </div>

    <div class="EmailReceipientsContainer">
        <p>{{'CCEmailCopy' | translate}}</p>
        <div class="ToggleCheckboxGroup">
          <div class="auto-save-toggle-container" *ngFor="let a of this.PartnerAgents;">
            <label class="auto-save-toggle">
              <input type="checkbox" [(ngModel)]="a.IsSelected">
              <span class="toggle-slider"></span>
            </label>
            <span class="auto-save-label">{{a.Email}}</span>
          </div>
        </div>
    </div>

      <!-- Message Textarea -->
      <div class="ModernFormGroup" style="width: 95%; margin-left: 2.5%;">
        <label class="ModernFormLabel">{{ 'YouMessageForOurTeam' | translate }}</label>
        <textarea class="ModernTextarea" rows="4" [(ngModel)]="ClientMessage" placeholder="{{ 'YouMessageForOurTeam' | translate }}"></textarea>
      </div>

      <!-- Final Dispatch Information -->
      <div class="ModernPopupInfoBox" *ngIf="this.ShippingDetails?.ShippingServiceType?.Name || this.ShippingDetails?.ShippingCompany?.Name">
        <i class="material-icons">info_outline</i>
        <span>
          <span *ngIf="this.ShippingDetails?.ShippingServiceType?.Name">({{this.ShippingDetails?.ShippingServiceType?.Name}})</span>
          <span class="NewLine" *ngIf="this.ShippingDetails?.ShippingCompany?.Name">{{'ShippingCompany' | translate}} ({{this.ShippingDetails?.ShippingCompany?.Name}})</span>
        </span>
      </div>
    </div>

    <div class="ModernPopupFooter">
      <button class="GridCommandButton GridCommandButtonGreen" (click)="SendDispatchEmailClientRequest();" [disabled]="this.parent.loading" *ngIf="this.ShippingDetails.ShippingServiceType || this.ShippingDetails?.ShippingResponsability?.ID === 0">
        <i class="material-icons">check</i>
        <span>{{ this.ShippingDetails?.ShippingResponsability?.ID === 0 ? ('FinalizePackingOurBoxes' | translate) : ('SendRequest' | translate) }}</span>
      </button>
    </div>
  </div>
</div>

<div class="EditContainer animated fadeInDown" *ngIf="this.ShowEditContainer == true;">
    <div class="EditContainerCloseButton" (click)="this.ShowEditContainer = false;">
        <i class="material-icons">close</i>
    </div>
    <div class="EditContainerHeadder">
      <p class="EditContainerHeadderTitle">
        <span class="EditContainerReferenceNumber">{{CurrentOrder.ReferenceNumber}}</span>
        <span class="EditContainerDebatorPO" *ngIf="CurrentOrder?.DebatorPO?.length > 0;">{{CurrentOrder.DebatorPO}}</span>
      </p>
    </div>
    <div class="EditContainerBody">

      <div class="EditContainerBodyStatus unSelectable">
        <span class="EditContainerBodyStatusTitle">Status: </span>
        <span class="OrdersRowColInfoStatusSpan" [ngClass]="{'NewOrderStatus': CurrentOrder.OfferRequestStatus.ID == 0, 'ProcessingOrderStatus': CurrentOrder.OfferRequestStatus.ID == 1,'PartiallyConfirmedOrderStatus': CurrentOrder.OfferRequestStatus.ID == 9,'ConfirmedOrderStatus': CurrentOrder.OfferRequestStatus.ID == 10, 'CanceledOrderStatus': CurrentOrder.OfferRequestStatus.ID == 11}">{{CurrentOrder.OfferRequestStatus.Name}}</span>
      </div>

      <div class="EditContainerBodySection">
        <div class="EditContainerBodySectionTitle unSelectable">
          <i class="material-icons">info</i>
          <span>{{'GeneralInfomration' | translate}}</span>
          <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderGeneralInformation = true;" *ngIf="this.ShowOrderGeneralInformation == false;">keyboard_arrow_right</i>
          <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderGeneralInformation = false;" *ngIf="this.ShowOrderGeneralInformation == true;">keyboard_arrow_down</i>
        </div>
  
        <div class="DottedSectionButton" *ngIf="this.ShowOrderGeneralInformation == false;" (click)="this.ShowOrderGeneralInformation = true;">
          <span>...</span>
        </div>
  
        <div *ngIf="this.ShowOrderGeneralInformation == true;">
          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'RequestNumber' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'RequestNumber' | translate}}" [(ngModel)]="this.CurrentOrder.ReferenceNumber" matInput>
            </div>
          </div>
    
            <div class="EditContainerBodyTextBoxContainer">
              <div class="TextBoxTitle">{{'DebatorPO' | translate}}</div> 
              <div class="CentralTextBoxContainer">
              <input style="letter-spacing: 2px;font-weight: 500;color: #f60;" type="text" class="TextBoxContainer" placeholder="{{'DebatorPO' | translate}}" [(ngModel)]="this.CurrentOrder.DebatorPO" matInput>
              </div>
            </div>
    
            <div class="EditContainerBodyTextBoxContainer">
              <div class="TextBoxTitle">{{'Uploader' | translate}}</div> 
              <div class="CentralTextBoxContainer">
              <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'UserUploader' | translate}}" [(ngModel)]="this.CurrentOrder.UserUploader.UIName" matInput>
              </div>
            </div>
    
            <div class="EditContainerBodyTextBoxContainer">
              <div class="TextBoxTitle">{{'Manager' | translate}}</div> 
              <div class="CentralTextBoxContainer">
              <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'UserUploader' | translate}}" [(ngModel)]="this.CurrentOrder.UserManager.UIName" matInput>
              </div>
            </div>
  
            <div class="CartSummary unSelectable CartSummarySmaller">
              <div class="CartSummaryTitle">
                <p>{{'OrderContactAgents' | translate}}</p>
              </div>
            
              <div class="PartnerAgentRow" *ngFor="let agent of this.CurrentOrder.Cart.Partner?.PartnerAgents" [ngClass]="{ 'UnSelectedAgent': agent.IsSelected != true}" (click)="agent.IsSelected = !agent.IsSelected;">
                <p>{{agent.Email}}</p>
                <i class="material-icons" *ngIf="agent.IsSelected == true;" style="color: #32aa3a;">check</i>
                <i class="material-icons" *ngIf="agent.IsSelected != true;" style="color: #fd4f57;">close</i>
              </div>
            </div>
        </div>
      </div>

        <div class="EditContainerBodySection">
          <div class="EditContainerBodySectionTitle unSelectable">
            <i class="material-icons">insert_drive_file</i>
            <span>{{'BillingInformation' | translate}}</span>
            <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderBillingInformation = true;" *ngIf="this.ShowOrderBillingInformation == false;">keyboard_arrow_right</i>
            <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderBillingInformation = false;" *ngIf="this.ShowOrderBillingInformation == true;">keyboard_arrow_down</i>
          </div>
  
          <div class="DottedSectionButton" *ngIf="this.ShowOrderBillingInformation == false;" (click)="this.ShowOrderBillingInformation = true;">
            <span>...</span>
          </div>
  
         <div *ngIf="this.ShowOrderBillingInformation == true;">
          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'Name' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'Name' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.Name" matInput>
            </div>
          </div>

          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'VAT' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'VAT' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.VAT" matInput>
            </div>
          </div>

          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'COCRegNumber' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'COCRegNumber' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.COCRegNumber" matInput>
            </div>
          </div>

          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'Country' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'Country' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.BillingAddress.Country.Name" matInput>
            </div>
          </div>
  
          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'StateProvince' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'StateProvince' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.BillingAddress.StateProvince" matInput>
            </div>
          </div>
  
          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'City' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'City' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.BillingAddress.City" matInput>
            </div>
          </div>
  
          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'AddressLine' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'AddressLine' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.BillingAddress.AddressLine" matInput>
            </div>
          </div>
         </div>
        </div>

        <div class="EditContainerBodySection">
          <div class="EditContainerBodySectionTitle unSelectable">
            <i class="material-icons">airplanemode_on</i>
            <span>{{'ShippingAddresses' | translate}}</span>
            <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderShippingInformation = true;" *ngIf="this.ShowOrderShippingInformation == false;">keyboard_arrow_right</i>
            <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderShippingInformation = false;" *ngIf="this.ShowOrderShippingInformation == true;">keyboard_arrow_down</i>
          </div>
  
          <div class="DottedSectionButton" *ngIf="this.ShowOrderShippingInformation == false;" (click)="this.ShowOrderShippingInformation = true;">
            <span>...</span>
          </div>
  
           <div *ngIf="this.ShowOrderShippingInformation == true;">
            <mat-form-field appearance="outline"class="EditContainerBodyDropDown" *ngIf="this.CurrentOrder.Cart.Partner.ShippingAddresses?.length > 0">
              <mat-label>{{ 'ShippingAddresses' | translate }}</mat-label>
              <mat-select name="ShippingAddresses" [compareWith]="this.parent.compareFn" [(ngModel)]="this.CurrentOrder.ShippingAddress" style="height: 30px;padding-top: 7px;">
                <mat-option *ngFor="let a of this.CurrentOrder.Cart.Partner.ShippingAddresses" [value]="a">
                  {{a.Country.Name}} {{a.City}} {{a.AddressLine}}
                </mat-option>
              </mat-select>
            </mat-form-field>
  
          <mat-form-field appearance="outline" class="EditContainerBodyDropDown">
            <mat-label>{{ 'Country' | translate }}</mat-label>
            <mat-select disabled="true" name="ShippingAddresses" [compareWith]="this.parent.compareFn" [(ngModel)]="this.CurrentOrder.ShippingAddress.Country" style="height: 30px;padding-top: 7px;">
              <mat-option *ngFor="let c of this.parent.masterData.Countries" [value]="c">
                {{c.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  
          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'StateProvince' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'StateProvince' | translate}}" [(ngModel)]="this.CurrentOrder.ShippingAddress.State" matInput>
          </div>
          </div>
  
          <div class="EditContainerBodyTextBoxContainer">
          <div class="TextBoxTitle">{{'Partners.PartnerWindow.City' | translate}}</div> 
          <div class="CentralTextBoxContainer">
          <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'Partners.PartnerWindow.City' | translate}}" [(ngModel)]="this.CurrentOrder.ShippingAddress.City" matInput>
          </div>
          </div>
  
          <div class="EditContainerBodyTextBoxContainer">
          <div class="TextBoxTitle">{{'Partners.PartnerWindow.AddressLine' | translate}}</div> 
          <div class="CentralTextBoxContainer">
          <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'Partners.PartnerWindow.AddressLine' | translate}}" [(ngModel)]="this.CurrentOrder.ShippingAddress.AddressLine" matInput>
          </div>
          </div>
  
          <div class="EditContainerBodyTextBoxContainer">
          <div class="TextBoxTitle">{{'ZipCode' | translate}}</div> 
          <div class="CentralTextBoxContainer">
          <input disabled="true" style="letter-spacing: 2px;font-weight: 500;" type="text" class="TextBoxContainer" placeholder="{{'ZipCode' | translate}}" [(ngModel)]="this.CurrentOrder.ShippingAddress.ZipCode" matInput>
          </div>
          </div>
           </div>
        </div>

        <div class="EditContainerBodySection">
          <div class="EditContainerBodySectionTitle unSelectable">
            <i class="material-icons">shopping_cart</i>
            <span>{{'Products' | translate}}</span>
            <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderProductsInformation = true;" *ngIf="this.ShowOrderProductsInformation == false;">keyboard_arrow_right</i>
            <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderProductsInformation = false;" *ngIf="this.ShowOrderProductsInformation == true;">keyboard_arrow_down</i>
          </div>

          <div class="DottedSectionButton" *ngIf="this.ShowOrderProductsInformation == false;" (click)="this.ShowOrderProductsInformation = true;">
            <span>...</span>
          </div>

          <div *ngIf="this.ShowOrderProductsInformation == true;">
            <div class="GridContainer" (keydown)="this.parent.handleKeyDown($event)">
              <div class="GridRow">
                <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(5% - 2px);">
                  #
                </div>
            
                <div class="GridCol GridHeadderCol unSelectable leftText" style="width: Calc(15% - 2px);">
                  {{'Brand' | translate}}
                </div>
            
              <div class="GridCol GridHeadderCol unSelectable leftText" style="width: Calc(45% - 2px);" matTooltip="{{ 'ProductNamePartNumberDescription' | translate}}" matTooltipClass='neutral-tool-tip'>
                 {{'ProductNamePartNumber' | translate}}
              </div>
            
              <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(5% - 2px);">
                {{'Quantity' | translate}}
              </div>
            
              <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(10% - 2px);">
                {{'Price' | translate}}
              </div>
            
              <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(10% - 2px);">
                {{'Total' | translate}}
              </div>
            
              <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(10% - 2px);">
                {{'ETA' | translate}}
              </div>
              </div>
            
              <div class="GridRow" *ngFor="let item of this.CurrentOrder.Cart?.Items; let i = index;">
                <div class="GridCol" style="width: Calc(5% - 2px);" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
                  {{i + 1}}
                </div>
            
                <div class="GridCol leftText" style="width: Calc(15% - 2px);  cursor: pointer;" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}" (click)="this.parent.InitializeSearchProduct(item);">
                  <span *ngIf="item?.CartItemStatus?.ID >= 0;">{{item?.Product?.Brand?.Name}}</span>
                  <span *ngIf="item?.CartItemStatus?.ID == -1;"></span>
                  <span *ngIf="item?.CartItemStatus?.ID == -2 && item?.UIProductValue?.length > 0 && item?.WasSearchedFor == true && item.UserSelectedBrand == null;">
                  </span>
                  <span *ngIf="item?.CartItemStatus?.ID == -2 && item?.UIProductValue?.length > 0 && item?.WasSearchedFor == true && item.UserSelectedBrand != null;">
                    {{item?.UserSelectedBrand?.Name}}
                  </span>
            
                  <div *ngIf="item.ShowBrandSearchResults == true;" class="GridBrandSearchResults">
                    <div class="GridBrandSearchResultsTopSearch">
                      <input type="text" placeholder="ex: SIEMENS" [(ngModel)]="this.parent.brandSearch" class="GridBrandSearchInput" matInput (ngModelChange)="this.parent.GetBrandsFilteredWithSuggestion(this.parent.brandSearch);"/>
                    </div>
                    <div class="GridBrandSearchResultsBody" *ngIf="this.parent.BrandsLoading != true;">
                      <div class="GridBrandSearchRow" *ngFor="let brand of this.parent.Brands; let b = index;" (click)="this.parent.SelectItemBrand(item, brand);">
                        <span>{{brand.Name}}</span>
                      </div>
                    </div>
                    <mat-spinner *ngIf="this.parent.BrandsLoading == true;" diameter="25" class="BrandsLoadingSpinner"></mat-spinner>
                  </div>
                </div>
            
                <div class="GridCol leftText" style="width: Calc(45% - 2px); background: #fff;padding-left: 0!important; cursor: pointer;" [ngClass]="{'awaitingChoiceMarkedRows': item?.CartItemStatus?.ID == -1, 'notFoundMarkedRows': item?.CartItemStatus?.ID == -2 && item?.WasSearchedFor == true, 'validMarkedRows': item?.CartItemStatus?.ID == 1, 'invalidMarkedRows': item?.CartItemStatus?.ID == 0}">
                  <textarea disabled="true" *ngIf="item.LoadingCell != true;" class="GridColFullText" type="text" (click)="this.parent.InitializeSearchProduct(item);" [(ngModel)]="item.UIProductValue" matInput (ngModelChange)="this.parent.searchTermUpdate.next($event)"></textarea>
                  <input disabled="true" *ngIf="item.LoadingCell == true;" class="GridColFullText" type="text" matInput (ngModelChange)="this.parent.OnlyNumbers($event)"/>
                  <i class="material-icons cellCheckIcon" *ngIf="item?.CartItemStatus?.ID == 1;">check</i>
                  <mat-spinner *ngIf="item.LoadingCell == true;" diameter="25" class="CellSpinner"></mat-spinner>
                  <div *ngIf="item.ShowSearchResults == true && item?.SearchResults?.length > 0;" class="itemChoiceContainer">
                    <div *ngFor="let s of this.item.SearchResults; let j = index;" class="cellSearchResultRow" (click)="this.parent.SelectGridSearchResult(s, item);" [ngClass]="{'SelectedOfferRow': s.IsSelected == true}">
                      <span>{{s.FKBrandName}}</span>  
                      <span>{{s.ProductName}}</span> <span *ngIf="s.ProductPartNumber?.length > 0;">(PN: {{s.ProductPartNumber}})</span>
                      <i class="material-icons SelectedGridSearchResult" *ngIf="s.IsSelected == true;">check</i>
                    </div>
                  </div>
                </div>
            
                <div class="GridCol" style="width: Calc(5% - 2px); background: #fff;" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
                  <div class="MOQSign" *ngIf="item?.SelectedOffer?.ChangedQunatityFromMOQ == true" matTooltip="{{'MOQDesc' | translate}} {{item.SelectedOffer.MOQ}}" matTooltipClass='neutral-tool-tip'></div>
                  <input disabled="true" class="GridColFullText" type="text" [(ngModel)]="item.Quantity" matInput *ngIf="item.Quantity > 0" (ngModelChange)="this.parent.OnlyNumbers($event)" (change)="this.parent.ChangeGridCellItem(item);"/>
                </div>
            
                <div class="GridCol" style="width: Calc(10% - 2px);" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
                  {{item.Price?.UIUnitPrice}} {{item.Price?.Currency?.Symbol}}
                </div>
            
                <div class="GridCol" style="width: Calc(10% - 2px);" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
                  {{item.Price?.UIQtyPrice}} {{item.Price?.Currency?.Symbol}}
                </div>
            
              <div class="GridCol" style="width: Calc(10% - 2px);" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
                <span class="DottStatus" *ngIf="item.RequestDeliveryStatus?.ID == -1" style="background: #f60;" matTooltip="{{item.RequestDeliveryStatus?.Name}}" matTooltipClass='neutral-tool-tip'></span>
                <span class="DottStatus" *ngIf="item.RequestDeliveryStatus?.ID == 0" style="background: #32aa3a;" matTooltip="{{item.RequestDeliveryStatus?.Name}}" matTooltipClass='neutral-tool-tip'></span>
                <span class="DottStatus" *ngIf="item.RequestDeliveryStatus?.ID == 1" matTooltip="{{item.RequestDeliveryStatus?.Name}}" matTooltipClass='neutral-tool-tip'></span>
                <span *ngIf="item.SelectedOffer?.LeadTime != null;">{{item.SelectedOffer?.LeadTime?.Units}} {{item.SelectedOffer?.LeadTime?.Type?.Name}}</span>
                <span *ngIf="item.SelectedOffer?.LeadTime == null;">------</span>
              </div>
              </div>
            </div>
          </div>
        </div>

    </div>

    <div class="EditContainerControlls">
      <button class="GridCommandButton GridCommandButtonBlue EditContainerControllsButton">
        <i class="material-icons">save_alt</i>
        <span>{{'Save' | translate}}</span>
      </button>

      <!-- <button class="GridCommandButton EditContainerControllsButton" style="float: right; margin-right: 2.5%;color: #fff;">
        <i class="material-icons">content_copy</i>
        <span>{{'Copy' | translate}}</span>
      </button> -->
    </div>
</div>

<div class="profile-container" *ngIf="ShowOrderDetailsPage != true;">

  <div class="profile-header">
    <h1>{{'Orders' | translate}}</h1>
  </div>

  <div class="profile-card">
    <div class="self-service-tabs">
      <button class="self-service-tab" [class.active]="ShowOrders == true && ShowTransitItems == false" (click)="this.ShowOrdersClick();">
        <i class="material-icons">shopping_cart</i>
        <span>{{'Orders' | translate}}</span>
      </button>

      <button class="self-service-tab" [class.active]="ShowOrders == false && ShowTransitItems == false" (click)="this.ShowReadyItems();">
        <i class="material-icons">inventory_2</i>
        <span>{{'ReadyItems' | translate}}</span>
      </button>

      <button class="self-service-tab" [class.active]="ShowTransitItems == true" (click)="this.ShowTransitItemsClick();">
        <i class="material-icons">local_shipping</i>
        <span>{{'TransitItems' | translate}}</span>
      </button>
    </div>

    <div class="card-content">

  <div class="ButtonsSubContainer" *ngIf="ShowOrders == false && ShowTransitItems == false;">
    <div class="subsection-header" style="margin: 14px 0 10px 0;">
      <i class="material-icons">inventory_2</i>
      <span>{{'MyReadyItems' | translate}}</span>
    </div>

    <!-- Open Boxes / Shipping Options Container - Always visible -->
    <div class="open-boxes-container" *ngIf="!this.loadingBoxes">

      <!-- Dropdowns Row -->
      <div class="ReadyItemsDropdownsRow" *ngIf="this.parent.loading != true;">
        <!-- Shipping Responsibility Dropdown -->
        <div class="ReadyItemsDropdownWrapper">
          <div class="CustomDropdownContainer">
            <div class="SendEmailOverlayTransparent" *ngIf="showShippingResponsabilityResults" (click)="showShippingResponsabilityResults = false"></div>

            <div class="CustomDropdownBar" (click)="showShippingResponsabilityResults = !showShippingResponsabilityResults">
              <span class="dropdown-label">{{ 'ShippingResponsability' | translate }}</span>
              <i class="material-icons dropdown-icon-left">local_shipping</i>
              <i class="material-icons send-email-icon" [style.color]="this.ShippingDetails?.ShippingResponsability?.ID != null ? '#4caf50' : '#f44336'">
                {{ this.ShippingDetails?.ShippingResponsability?.ID != null ? 'check_circle' : 'cancel' }}
              </i>
              <input type="text" class="CustomDropdownInput" [value]="this.ShippingDetails?.ShippingResponsability?.Name || ''" readonly />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>

            <div class="CustomDropdownResults" *ngIf="showShippingResponsabilityResults">
              <div class="CustomDropdownResult" *ngFor="let s of this.ShippingResponsabilities" (click)="selectShippingResponsability(s)">
                <div class="CustomDropdownResultMain">
                  <i class="material-icons" [style.color]="this.ShippingDetails?.ShippingResponsability?.ID === s.ID ? '#4caf50' : '#f44336'">
                    {{ this.ShippingDetails?.ShippingResponsability?.ID === s.ID ? 'check_circle' : 'cancel' }}
                  </i>
                  <span class="CustomDropdownResultText">{{s.Name}} ({{s.Description}})</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Shipping Company Dropdown -->
        <div class="ReadyItemsDropdownWrapper" [style.opacity]="this.ShippingDetails?.ShippingResponsability?.ID === 0 ? '0.4' : '1'" [style.pointer-events]="this.ShippingDetails?.ShippingResponsability?.ID === 0 ? 'none' : 'auto'">
          <div class="CustomDropdownContainer">
            <div class="SendEmailOverlayTransparent" *ngIf="showShippingCompanyResults" (click)="showShippingCompanyResults = false"></div>

            <div class="CustomDropdownBar" [class.disabled]="this.ShippingDetails?.ShippingResponsability?.ID == null || this.ShippingDetails?.ShippingResponsability?.ID === 0" (click)="this.ShippingDetails?.ShippingResponsability?.ID != null && this.ShippingDetails?.ShippingResponsability?.ID !== 0 && (showShippingCompanyResults = !showShippingCompanyResults)">
              <span class="dropdown-label">{{ 'ShippingCompany' | translate }}</span>
              <img *ngIf="this.ShippingDetails?.ShippingCompany?.ImagePath" [src]="this.parent.BackendServiceUrl + this.ShippingDetails?.ShippingCompany?.ImagePath" class="shipping-company-logo-selected" />
              <i *ngIf="!this.ShippingDetails?.ShippingCompany?.ImagePath" class="material-icons dropdown-icon-left">business</i>
              <i class="material-icons send-email-icon" [style.color]="this.ShippingDetails?.ShippingCompany?.ID ? '#4caf50' : '#f44336'">
                {{ this.ShippingDetails?.ShippingCompany?.ID ? 'check_circle' : 'cancel' }}
              </i>
              <input type="text" class="CustomDropdownInput" [value]="this.ShippingDetails?.ShippingCompany?.Name || ''" readonly />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>

            <div class="CustomDropdownResults" *ngIf="showShippingCompanyResults && this.ShippingDetails?.ShippingResponsability?.ID != null">
              <div class="CustomDropdownResult" *ngFor="let s of this.ShippingCompanies" (click)="selectShippingCompany(s)">
                <div class="CustomDropdownResultMain">
                  <i class="material-icons" [style.color]="this.ShippingDetails?.ShippingCompany?.ID === s.ID ? '#4caf50' : '#f44336'">
                    {{ this.ShippingDetails?.ShippingCompany?.ID === s.ID ? 'check_circle' : 'cancel' }}
                  </i>
                  <img *ngIf="s.ImagePath" [src]="this.parent.BackendServiceUrl + s.ImagePath" class="shipping-company-logo-dropdown" />
                  <span class="CustomDropdownResultText">{{s.Name}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Shipping Service Type Dropdown -->
        <div class="ReadyItemsDropdownWrapper" [style.opacity]="this.ShippingDetails?.ShippingResponsability?.ID === 0 ? '0.4' : '1'" [style.pointer-events]="this.ShippingDetails?.ShippingResponsability?.ID === 0 ? 'none' : 'auto'">
          <div class="CustomDropdownContainer">
            <div class="SendEmailOverlayTransparent" *ngIf="showShippingServiceTypeResults" (click)="showShippingServiceTypeResults = false"></div>

            <div class="CustomDropdownBar" [class.disabled]="this.ShippingDetails?.ShippingResponsability?.ID == null || this.ShippingDetails?.ShippingResponsability?.ID === 0" (click)="this.ShippingDetails?.ShippingResponsability?.ID != null && this.ShippingDetails?.ShippingResponsability?.ID !== 0 && (showShippingServiceTypeResults = !showShippingServiceTypeResults)">
              <span class="dropdown-label">{{ 'ShippingServiceType' | translate }}</span>
              <i class="material-icons dropdown-icon-left">flight_takeoff</i>
              <i class="material-icons send-email-icon" [style.color]="this.ShippingDetails?.ShippingServiceType?.ID ? '#4caf50' : '#f44336'">
                {{ this.ShippingDetails?.ShippingServiceType?.ID ? 'check_circle' : 'cancel' }}
              </i>
              <input type="text" class="CustomDropdownInput" [value]="this.ShippingDetails?.ShippingServiceType?.Name || ''" readonly />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>

            <div class="CustomDropdownResults" *ngIf="showShippingServiceTypeResults && this.ShippingDetails?.ShippingResponsability?.ID != null">
              <div class="CustomDropdownResult" *ngFor="let s of this.ShippingServiceTypes" (click)="selectShippingServiceType(s)">
                <div class="CustomDropdownResultMain">
                  <i class="material-icons" [style.color]="this.ShippingDetails?.ShippingServiceType?.ID === s.ID ? '#4caf50' : '#f44336'">
                    {{ this.ShippingDetails?.ShippingServiceType?.ID === s.ID ? 'check_circle' : 'cancel' }}
                  </i>
                  <span class="CustomDropdownResultText">{{s.Name}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Shipping Address Row -->
      <div class="ReadyItemsDropdownsRow" *ngIf="this.parent.loading != true;">
        <!-- Shipping Address Dropdown -->
        <div class="ReadyItemsDropdownWrapper">
          <div class="CustomDropdownContainer">
            <div class="SendEmailOverlayTransparent" *ngIf="showShippingAddressResults" (click)="showShippingAddressResults = false"></div>

            <div class="CustomDropdownBar" (click)="showShippingAddressResults = !showShippingAddressResults">
              <span class="dropdown-label">{{ 'ShippingAddresses' | translate }}</span>
              <i class="material-icons dropdown-icon-left">location_on</i>
              <i class="material-icons send-email-icon" [style.color]="this.SelectedShippingAddress?.ID ? '#4caf50' : '#f44336'">
                {{ this.SelectedShippingAddress?.ID ? 'check_circle' : 'cancel' }}
              </i>
              <input type="text" class="CustomDropdownInput" [value]="this.SelectedShippingAddress ? (this.SelectedShippingAddress.Country?.Name + ' ' + this.SelectedShippingAddress.State + ' ' + this.SelectedShippingAddress.City + ' ' + this.SelectedShippingAddress.AddressLine) : ''" readonly />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>

            <div class="CustomDropdownResults" *ngIf="showShippingAddressResults">
              <div class="CustomDropdownResult" *ngFor="let a of this.PartnerShippingAddresses" (click)="selectShippingAddress(a)">
                <div class="CustomDropdownResultMain">
                  <i class="material-icons" [style.color]="this.SelectedShippingAddress?.ID === a.ID ? '#4caf50' : '#f44336'">
                    {{ this.SelectedShippingAddress?.ID === a.ID ? 'check_circle' : 'cancel' }}
                  </i>
                  <span class="CustomDropdownResultText">{{a.Country?.Name}} {{a.State}} {{a.City}} {{a.AddressLine}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Button Row -->
      <div class="ReadyItemsButtonRow" *ngIf="this.parent.loading != true;">
        <button (click)="this.ShowShipmentRequestPopup = true" class="RequestItemsShipmentButton" [disabled]="this.parent.loading" matTooltip="{{ 'RequestItemsShipmentDescription' | translate}}" matTooltipClass='neutral-tool-tip'>
          <i class="material-icons">check</i>
          <span>{{ this.ShippingDetails?.ShippingResponsability?.ID === 0 ? ('FinalizePackingOurBoxes' | translate) : ('RequestItemsShipment' | translate) }}</span>
        </button>
        <button *ngIf="!this.PartnerOpenBoxes?.ShippingCosts || this.PartnerOpenBoxes?.ShippingCosts?.length === 0" class="GetShippingCostsButton" [disabled]="this.parent.loading" (click)="GetPartnerOpenBoxesShippingCosts()" matTooltip="{{ 'CompareAndManagePartnerOpenBoxesDescription' | translate}}" matTooltipClass='neutral-tool-tip'>
          <i class="material-icons">local_atm</i>
          <span>{{ 'CompareAndManagePartnerOpenBoxes' | translate }}</span>
        </button>
      </div>

      <div class="open-boxes-header" *ngIf="this.SupplierClientOpenBoxes?.length > 0">
        <i class="material-icons">inventory_2</i>
        <span>{{'OpenBoxesInWarehouse' | translate}}</span>
      </div>

      <table class="open-boxes-table" style="table-layout: fixed;" *ngIf="this.SupplierClientOpenBoxes?.length > 0">
        <thead>
          <tr>
            <th style="width: 5%;">#</th>
            <th style="width: 15%; text-align: center;">{{'Length' | translate}} (cm)</th>
            <th style="width: 15%; text-align: center;">{{'Width' | translate}} (cm)</th>
            <th style="width: 15%; text-align: center;">{{'Height' | translate}} (cm)</th>
            <th style="width: 15%; text-align: right;">{{'Weight' | translate}} (kg)</th>
            <th style="width: 35%; text-align: right;">{{'Dimensions' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let box of this.SupplierClientOpenBoxes; let i=index;">
            <td class="text-center">{{i + 1}}</td>
            <td class="text-center">{{box.Length}}</td>
            <td class="text-center">{{box.Width}}</td>
            <td class="text-center">{{box.Height}}</td>
            <td class="text-right">{{box.Weight}}</td>
            <td style="text-align: right;">
              <span class="dimensions-badge">{{box.Length}} × {{box.Width}} × {{box.Height}} cm</span>
              <span class="weight-badge">{{box.Weight}} kg</span>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Shipping Costs Table -->
      <table class="open-boxes-table" *ngIf="this.PartnerOpenBoxes?.ShippingCosts && this.PartnerOpenBoxes?.ShippingCosts?.length > 0" style="margin-top: 20px; table-layout: fixed;">
        <thead>
          <tr>
            <th style="width: 5%;">#</th>
            <th style="width: 15%;">{{'ShippingCompany' | translate}}</th>
            <th style="width: 15%; text-align: center;">{{'ShippingServiceType' | translate}}</th>
            <th style="width: 15%;"></th>
            <th style="width: 15%; text-align: right;">{{'EstimatedShippingCost' | translate}}</th>
            <th style="width: 35%; text-align: right;"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let cost of this.PartnerOpenBoxes.ShippingCosts; let i=index;">
            <td class="text-center">{{i + 1}}</td>
            <td>
              <div style="display: flex; align-items: center; gap: 10px;">
                <img *ngIf="cost.ShippingCompany?.ImagePath" [src]="this.parent.BackendServiceUrl + cost.ShippingCompany.ImagePath" style="height: 30px; object-fit: contain;" />
                <span>{{cost.ShippingCompany?.Name}}</span>
              </div>
            </td>
            <td class="text-center">
              <div style="display: flex; align-items: center; justify-content: center; gap: 5px;">
                <i class="material-icons" style="font-size: 18px; color: #0082e6;" *ngIf="cost.ShippingServiceType?.ID == -1">local_shipping</i>
                <i class="material-icons" style="font-size: 18px; color: #32aa3a;" *ngIf="cost.ShippingServiceType?.ID == 1">flight_takeoff</i>
                <span>{{cost.ShippingServiceType?.Name}}</span>
              </div>
            </td>
            <td></td>
            <td class="text-right" style="font-weight: 600;">
              {{cost.Price?.UIUnitPrice | number:'1.2-2'}} {{getCurrencySymbol(cost.Price?.Currency?.ID)}}
            </td>
            <td style="text-align: right; padding-right: 14px;">
              <button class="festo-action-btn print-btn" style="margin-left: auto;" (click)="SelectShippingEstimate(cost)">
                <i class="material-icons">check_circle</i> {{'Select' | translate}}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modern Ready Items Table -->
    <div class="modern-table-container">
      <table class="modern-table">
        <thead>
          <tr>
            <th style="width: 50px;">#</th>
            <th style="width: 140px;">{{'ConfirmationNumber' | translate}}</th>
            <th style="width: 120px;">{{'YourInternalRefferenceNumber' | translate}}</th>
            <th style="width: 140px;">{{'Brand' | translate}}</th>
            <th>{{'Product' | translate}}</th>
            <th style="width: 80px; text-align: center;">{{'Quantity' | translate}}</th>
            <th style="width: 120px; text-align: right;">{{'Price' | translate}}</th>
            <th style="width: 120px; text-align: right;">{{'Total' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of this.ReadyItems; let j=index;" [ngClass]="{'status-canceled': item.ProgressStatus?.ID == -1, 'status-ready': item.ProgressStatus?.ID == 2, 'status-sent': item.ProgressStatus?.ID == 3}">
            <td class="text-center">{{j + 1}}</td>
            <td><span class="badge badge-success">{{item.CartItemOrderInfo?.ReferenceNumber}}</span></td>
            <td><span class="badge badge-orange">{{item.CartItemOrderInfo?.DebatorPO}}</span></td>
            <td><strong>{{item.Product?.Brand?.Name}}</strong></td>
            <td>
              <div class="product-info">
                <div class="product-name">{{item.Product?.Name}}</div>
                <div class="product-details">
                  <span *ngIf="item.Product?.PartNumber?.length > 0" class="detail-item">
                    <span class="detail-label">PN:</span> {{item.Product?.PartNumber}}
                  </span>
                  <span *ngIf="item.Product?.Stats?.HSCode?.length > 0" class="detail-item">
                    <span class="detail-label">HS:</span> {{item.Product?.Stats?.HSCode}}
                  </span>
                  <span *ngIf="item.Product?.Stats?.COO?.Name?.length > 0" class="detail-item">
                    <span class="detail-label">COO:</span> {{item.Product?.Stats?.COO?.ShortName}}
                  </span>
                  <span *ngIf="item.Product?.Stats?.Weight != null" class="detail-item">
                    <span class="detail-label">Weight:</span> {{item.Product?.Stats?.Weight}} {{item.Product?.Stats?.WeightMeasurementType?.Name}}
                  </span>
                </div>
              </div>
            </td>
            <td class="text-center"><strong>{{item.Quantity}}</strong></td>
            <td class="text-right">{{item.Price?.UIUnitPrice}} {{item.CartItemOrderInfo?.OrderCurrency?.Name}}</td>
            <td class="text-right"><strong>{{item.Price?.UIQtyPrice}} {{item.CartItemOrderInfo?.OrderCurrency?.Name}}</strong></td>
          </tr>
        </tbody>
        <tfoot *ngIf="this.ReadyItemsTotal > 0;">
          <tr class="total-row">
            <td colspan="7" class="text-right"><strong>{{'Total' | translate}}:</strong></td>
            <td class="text-right"><strong class="total-amount">{{ReadyItemsTotal}} {{ReadyItemsTotalCurrency}}</strong></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>

  <div class="ButtonsSubContainer" *ngIf="ShowTransitItems == true;">
    <div class="subsection-header" style="margin: 14px 0 10px 0;">
      <i class="material-icons">local_shipping</i>
      <span>{{'TransitItems' | translate}}</span>
    </div>

    <!-- Transit Items Explanation -->
    <div class="ModernPopupInfoBox" style="width: 100%; margin: 0 0 12px 0;">
      <i class="material-icons">info_outline</i>
      <span>
        <strong>{{'TransitItemsTitle' | translate}}</strong>
        <span class="NewLine">{{'TransitItemsDescription' | translate}}</span>
      </span>
    </div>

    <!-- No Transit Items Message -->
    <div *ngIf="!getFilteredTransitItems() || getFilteredTransitItems().length == 0" class="empty-state">
      <i class="material-icons">local_shipping</i>
      <p>{{'NoTransitItemsYet' | translate}}</p>
    </div>

    <!-- Modern Transit Items Table -->
    <div *ngIf="getFilteredTransitItems() && getFilteredTransitItems().length > 0" class="modern-table-container">
      <table class="modern-table">
        <thead>
          <tr>
            <th style="width: 50px;">#</th>
            <th style="width: 120px;">{{'YourPO' | translate}}</th>
            <th style="width: 140px;">{{'OurConfirmation' | translate}}</th>
            <th style="width: 140px;">{{'Brand' | translate}}</th>
            <th>{{'Product' | translate}}</th>
            <th style="width: 80px; text-align: center;">{{'Quantity' | translate}}</th>
            <th style="width: 130px; text-align: center;">{{'EstimatedArrival' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of getFilteredTransitItems(); let j=index;">
            <td class="text-center">{{j + 1}}</td>
            <td><span class="badge badge-orange">{{item.DebatorPO || '---'}}</span></td>
            <td><span class="badge badge-success">{{item.OrderRefferenceNumber || '---'}}</span></td>
            <td><strong>{{item.Brand?.Name || '---'}}</strong></td>
            <td>
              <div class="product-info">
                <div class="product-name">{{item.ProductName || '---'}}</div>
                <div class="product-details">
                  <span *ngIf="item.ProductPartNumber?.length > 0" class="detail-item">
                    <span class="detail-label">PN:</span> {{item.ProductPartNumber}}
                  </span>
                </div>
              </div>
            </td>
            <td class="text-center"><strong>{{item.Quantity || 0}}</strong></td>
            <td class="text-center">
              <span *ngIf="item.EstiMatedArrivalDate" class="badge badge-purple">{{item.EstiMatedArrivalDateUI}}</span>
              <span *ngIf="!item.EstiMatedArrivalDate" style="color: #999;">---</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

 <div class="ButtonsSubContainer" *ngIf="ShowOrders == true && ShowTransitItems == false;">
  <div class="OrderControlls">
    <div class="MainTitleBar">
        <!-- Period Dropdown -->
        <div class="FifteenPercentContainer">
          <div class="CustomDropdownContainer">
            <div class="SendEmailOverlayTransparent" *ngIf="showPeriodResults" (click)="showPeriodResults = false"></div>

            <div class="CustomDropdownBar" (click)="showPeriodResults = !showPeriodResults">
              <span class="dropdown-label">{{ 'Receptions.ChoosePeriod' | translate }}</span>
              <i class="material-icons dropdown-icon-left">date_range</i>
              <i class="material-icons send-email-icon" [style.color]="Filter.Period?.ID ? '#4caf50' : '#f44336'">
                {{ Filter.Period?.ID ? 'check_circle' : 'cancel' }}
              </i>
              <input type="text" class="CustomDropdownInput" [value]="Filter.Period?.Name || ''" readonly />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>

            <div class="CustomDropdownResults" *ngIf="showPeriodResults">
              <div class="CustomDropdownResult" *ngFor="let a of this.Periods" (click)="selectPeriod(a)">
                <div class="CustomDropdownResultMain">
                  <i class="material-icons" [style.color]="Filter.Period?.ID === a.ID ? '#4caf50' : '#f44336'">
                    {{ Filter.Period?.ID === a.ID ? 'check_circle' : 'cancel' }}
                  </i>
                  <span class="CustomDropdownResultText">{{a.Name}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- From Date -->
        <div class="FifteenPercentContainer">
          <div class="CustomDatePickerBar">
            <span class="dropdown-label">{{ 'Receptions.FromDate' | translate }}</span>
            <i class="material-icons dropdown-icon-left">event</i>
            <input matInput [matDatepicker]="dp" [formControl]="FromDate" [(ngModel)]="Filter.FromDate" (dateChange)="ClearPeriod()" class="CustomDateInput" readonly />
            <mat-datepicker-toggle matSuffix [for]="dp" class="CustomDateToggle"></mat-datepicker-toggle>
            <mat-datepicker #dp></mat-datepicker>
          </div>
        </div>

        <!-- To Date -->
        <div class="FifteenPercentContainer">
          <div class="CustomDatePickerBar">
            <span class="dropdown-label">{{ 'Receptions.ToDate' | translate }}</span>
            <i class="material-icons dropdown-icon-left">event</i>
            <input matInput [matDatepicker]="dp1" [formControl]="ToDate" [(ngModel)]="Filter.ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()" class="CustomDateInput" readonly />
            <mat-datepicker-toggle matSuffix [for]="dp1" class="CustomDateToggle"></mat-datepicker-toggle>
            <mat-datepicker #dp1></mat-datepicker>
          </div>
        </div>

        <!-- Filter Button -->
        <div class="FifteenPercentContainer" style="margin-top: 0;">
            <button class="ModernFilterButton" (click)="GetB2BClientOrders(1, this.OrdersSearchTerm);">
              <i class="material-icons">filter_alt</i>
              <span>{{ 'Filter' | translate }}</span>
            </button>
        </div>

    </div>

    <div class="MainTitleBar">

      <div class="ActiveFiltersContainer">
        <div class="ActiveFilter" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
          {{a.Name}}
          <i class="material-icons">close</i>
        </div>
      </div>
    </div>

    <div class="MainTitleBar">
      <!-- Center: Search -->
      <div class="MainOrdersSearchContainer">
        <input type="text" class="MainOrdersSearch" placeholder="{{'ClientSearchOrders' | translate}}" [(ngModel)]="OrdersSearchTerm" (ngModelChange)="this.ordersSearchTermUpdate.next($event)">
        <i class="material-icons" *ngIf="!(OrdersSearchTerm?.length > 0);">search</i>
        <i class="material-icons" *ngIf="(OrdersSearchTerm?.length > 0);" (click)="this.OrdersSearchTerm = ''; GetB2BClientOrders(1, this.OrdersSearchTerm);">close</i>
      </div>

      <!-- Right Side: Pagination Info & Controls -->
      <div class="RightPagination">

        <div class="PaginationControls">
          <button class="GridCommandButton PaginationButton" [disabled]="this.Filter.Pager.PageIndex == 1" (click)="GetB2BClientOrders(1, this.OrdersSearchTerm);">
            <i class="material-icons">first_page</i>
          </button>
          <button class="GridCommandButton PaginationButton" [disabled]="this.Filter.Pager.PageIndex == 1" (click)="GetB2BClientOrders(this.Filter.Pager.PageIndex - 1, this.OrdersSearchTerm);">
            <i class="material-icons">chevron_left</i>
          </button>

          <div class="PageNumberDisplay">
            <span class="CurrentPage">{{this.Filter.Pager.PageIndex}}</span>
            <span class="PageSeparator">/</span>
            <span class="TotalPages">{{this.Filter.Pager.Pages}}</span>
          </div>

          <button class="GridCommandButton PaginationButton" [disabled]="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages" (click)="GetB2BClientOrders(this.Filter.Pager.PageIndex + 1, this.OrdersSearchTerm);">
            <i class="material-icons">chevron_right</i>
          </button>
          <button class="GridCommandButton PaginationButton" [disabled]="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages" (click)="GetB2BClientOrders(this.Filter.Pager.Pages, this.OrdersSearchTerm);">
            <i class="material-icons">last_page</i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modern Orders Table -->
  <div class="ModernOrdersTable">
    <div class="ModernOrdersHeader">
        <div class="ModernOrdersHeaderCol" style="width: 5%;">
            <i class="material-icons">tag</i>
        </div>

        <div class="ModernOrdersHeaderCol" style="width: 17.5%;">
            {{'ID' | translate}}
        </div>

        <div class="ModernOrdersHeaderCol" style="width: 15%;">
            {{'Status' | translate}}
        </div>

        <div class="ModernOrdersHeaderCol" style="width: 10%;">
            {{'Date' | translate}}
        </div>

        <div class="ModernOrdersHeaderCol" style="width: 17.5%;">
            {{'DebatorPO' | translate}}
        </div>

        <div class="ModernOrdersHeaderCol" style="width: 7.5%;">
            {{'Total' | translate}}
        </div>

        <div class="ModernOrdersHeaderCol" style="width: 5%;">
            {{'Currency' | translate}}
        </div>

        <div class="ModernOrdersHeaderCol" style="width: 12.5%;">
            {{'Progress' | translate}}
        </div>

        <div class="ModernOrdersHeaderCol" style="width: 10%;">
            {{'Actions' | translate}}
        </div>
    </div>

    <div class="ModernOrdersBody">
       <div *ngIf="this.loadingOrders == false;">
        <div class="ModernOrdersRow" *ngFor="let o of this.Orders; let j=index;">
            <div class="ModernOrdersCol" style="width: 5%;">
                <span class="row-number">#{{j + 1}}</span>
            </div>

            <div (click)="GetClientOCDetails(o);" class="ModernOrdersCol order-id-col" style="width: 17.5%;">
                <span class="order-id-link">{{o.ReferenceNumber}}</span>
            </div>

            <div class="ModernOrdersCol" style="width: 15%;">
                <span class="modern-status-badge" [ngClass]="{'status-new': o.ProcessingStatus?.ID == 0, 'status-processing': o.ProcessingStatus?.ID == 1, 'status-completed': o.ProcessingStatus?.ID == 10}">
                    {{o.ProcessingStatus?.Name}}
                </span>
            </div>

            <div class="ModernOrdersCol" style="width: 10%;">
                <span class="order-date">{{o.EventRegisterUI}}</span>
            </div>

            <div class="ModernOrdersCol" style="width: 17.5%;">
                <span class="order-po">{{o.DebatorPO}}</span>
            </div>

            <div class="ModernOrdersCol" style="width: 7.5%;">
                <span class="order-total">{{o.Cart?.Total?.TotalQtyPriceNOVAT}}</span>
            </div>

            <div class="ModernOrdersCol" style="width: 5%;">
                <span class="order-currency">{{o.Cart?.Currency?.Name}}</span>
            </div>

            <div class="ModernOrdersCol" style="width: 12.5%; padding: 0 8px;">
                <div class="modern-progress-container" matTooltip="{{'ProgressReady' | translate}}: {{o.OrderStatistics?.ReadyProductsPercentage}}% • {{'ProgressInvoiced' | translate}}: {{o.OrderStatistics?.SendProductsPercentage}}%" matTooltipClass='neutral-tool-tip'>
                  <div class="modern-progress-bar modern-progress-bar-ready" [style.width.%]="o.OrderStatistics?.ReadyProductsPercentage"></div>
                  <div class="modern-progress-bar" [style.width.%]="o.OrderStatistics?.SendProductsPercentage"></div>
                  <span class="modern-progress-text" *ngIf="o.OrderStatistics?.ReadyProductsPercentage > 0">{{o.OrderStatistics?.ReadyProductsPercentage}}%</span>
                </div>
            </div>

            <div class="ModernOrdersCol" style="width: 10%;">
                <button (click)="GetClientOCDetails(o);" class="ModernDetailsButton">
                  <i class="material-icons" *ngIf="o.IsLoading != true;">visibility</i>
                  <span *ngIf="o.IsLoading != true;">{{'Details' | translate}}</span>
                  <mat-spinner *ngIf="o.IsLoading == true;" diameter="16" class="DetailsButtonSpinner"></mat-spinner>
                </button>
            </div>
        </div>
       </div>
       <div *ngIf="this.loadingOrders == true;" class="empty-state">
        <mat-spinner diameter="24" class="BrandsLoadingSpinner"></mat-spinner>
       </div>
    </div>
  </div>
 </div>
    </div><!-- /card-content -->
  </div><!-- /profile-card -->
</div><!-- /profile-container -->

<div class="OrderDetailsContainer CompactOrderDetails" *ngIf="ShowOrderDetailsPage == true;">
    <div class="OrderDetailsTitle">{{this.Order.ReferenceNumber}} / {{this.Order.EventRegisterUI}} - {{'DebatorPO' | translate}}: {{this.Order.DebatorPO}}</div>
    <div style="padding-bottom: 25px; border-bottom: solid 1px #aaa;" class="OrderDetailsTitle">Total: {{this.Order.Cart.Total.TotalQtyPriceNOVAT}} {{this.Order.Cart.Currency.Name}}</div>

    <div class="OrderDetailsTabsWrapper">
      <div class="OrderDetailsMenu" [ngClass]="{'SelectedOrderDetailsMenu': ShowOrderDetailsMenu == true}" (click)="SelectOrderDetailsMenu();">
        <i class="material-icons">description</i>
        <span>{{'Details' | translate}}</span>
      </div>
      <!-- <div class="OrderDetailsMenu" [ngClass]="{'SelectedOrderDetailsMenu': ShowOrderDocumentsMenu == true}" (click)="SelectOrderDocumentsMenu();">
        <i class="material-icons">insert_drive_file</i>
        <span>{{'Documents' | translate}} ({{this.Order?.Invoices?.length}})</span>
      </div> -->
      <div class="CrossLine"></div>
      <div class="OrderDetailsMenu SelectedOrderDetailsMenu" (click)="BackToOrders();">
        <i class="material-icons">arrow_back</i>
        <span>{{'Back' | translate}}</span>
      </div>
      <!-- <div class="OrderDetailsMenu" [ngClass]="{'SelectedOrderDetailsMenu': ShowOrderTrackingMenu == true}">
        <i class="material-icons">near_me</i>
        <span>{{'Tracking' | translate}}</span>
      </div> -->
    </div>

    <div class="OrderDetails" *ngIf="this.ShowOrderDetailsMenu == true;" style="border:none;">
      <!-- Festo-style Clean Order Info Grid -->
      <div class="festo-order-info-grid">
        <div class="festo-info-row">
          <div class="festo-info-label">{{'OrderID' | translate}}</div>
          <div class="festo-info-value">{{this.Order.ReferenceNumber}}</div>
        </div>

        <div class="festo-info-row">
          <div class="festo-info-label">{{'DebatorPO' | translate}}</div>
          <div class="festo-info-value">{{this.Order.DebatorPO}}</div>
        </div>

        <div class="festo-info-row">
          <div class="festo-info-label">{{'OrderDate' | translate}}</div>
          <div class="festo-info-value">{{this.Order.EventRegisterUI}}</div>
        </div>

        <div class="festo-info-row">
          <div class="festo-info-label">{{'Client' | translate}}</div>
          <div class="festo-info-value">{{this.Order.Cart.Partner.Name}}</div>
        </div>

        <div class="festo-info-row">
          <div class="festo-info-label">{{'Status' | translate}}</div>
          <div class="festo-info-value">
            <span class="festo-status-badge">{{this.Order.ProcessingStatus.Name}}</span>
          </div>
        </div>

        <div class="festo-info-row">
          <div class="festo-info-label">{{'Total' | translate}}</div>
          <div class="festo-info-value festo-total-value">{{this.Order.Cart.Total.TotalQtyPriceNOVAT}} {{this.Order.Cart.Currency.Name}}</div>
        </div>

        <!-- Invoice Selector -->
        <div *ngIf="this.Order?.Invoices?.length > 0" class="festo-info-row">
          <div class="festo-info-label">{{'Invoice' | translate}}</div>
          <div class="festo-info-value">
            <div class="invoice-selector-container">
              <div class="SendEmailOverlayTransparent" *ngIf="showInvoiceDropdown" (click)="showInvoiceDropdown = false"></div>
              <div class="CustomDropdownBar" (click)="showInvoiceDropdown = !showInvoiceDropdown">
                <i class="material-icons dropdown-icon-left" style="color: #34c759;">receipt_long</i>
                <input type="text" class="CustomDropdownInput" [value]="getSelectedInvoiceDisplay()" readonly />
                <span class="invoice-count-badge" *ngIf="this.Order?.Invoices?.length > 1">{{this.Order.Invoices.length}}</span>
                <i class="material-icons dropdown-icon">arrow_drop_down</i>
              </div>
              <div class="CustomDropdownResults" *ngIf="showInvoiceDropdown">
                <div class="CustomDropdownResult" *ngFor="let inv of this.Order.Invoices; let idx=index;"
                     (click)="selectInvoiceForView(inv); showInvoiceDropdown = false;">
                  <div class="CustomDropdownResultMain">
                    <i class="material-icons" [style.color]="inv.IsSelectedForView ? '#34c759' : '#c7c7cc'">
                      {{ inv.IsSelectedForView ? 'check_circle' : 'radio_button_unchecked' }}
                    </i>
                    <span class="CustomDropdownResultText">{{'Invoice' | translate}} {{idx + 1}} — {{inv.AccountingNumber.DisplayValue}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Selected Invoice Actions -->
        <ng-container *ngFor="let invoice of this.Order?.Invoices;">
          <ng-container *ngIf="invoice.IsSelectedForView">
            <div class="festo-info-row">
              <div class="festo-info-label">{{'Actions' | translate}}</div>
              <div class="festo-info-value">
                <div class="festo-action-buttons">
                  <button class="festo-action-btn download-btn"
                          (click)="GetInvoiceByAccountingDisplayValue(invoice, false);"
                          matTooltip="{{ 'Download PDF' | translate}}"
                          matTooltipClass='neutral-tool-tip'>
                    <i class="material-icons">download</i>
                    <span>{{'Download' | translate}}</span>
                  </button>
                  <button class="festo-action-btn print-btn"
                          (click)="GetInvoiceByAccountingDisplayValue(invoice, true);"
                          matTooltip="{{ 'Print Document' | translate}}"
                          matTooltipClass='neutral-tool-tip'>
                    <i class="material-icons">print</i>
                    <span>{{'Print' | translate}}</span>
                  </button>
                </div>
              </div>
            </div>

            <div *ngIf="invoice.Details?.ShippingDetails?.ShippingCompany?.Name?.length > 0" class="festo-info-row">
              <div class="festo-info-label">{{'Carrier' | translate}}</div>
              <div class="festo-info-value">
                <div class="festo-carrier-info">
                  <img *ngIf="invoice.Details.ShippingDetails?.ShippingCompany?.ImagePath?.length > 0;"
                       [src]="this.parent.BackendServiceUrl + invoice.Details?.ShippingDetails?.ShippingCompany?.ImagePath"
                       class="festo-carrier-logo"
                       [alt]="invoice.Details?.ShippingDetails?.ShippingCompany?.Name"/>
                  <span class="festo-carrier-name">{{invoice.Details?.ShippingDetails?.ShippingCompany?.Name}}</span>
                </div>
              </div>
            </div>

            <div *ngIf="invoice.Details?.ShippingDetails?.ShippingCompany?.TrackingUrl?.length > 0" class="festo-info-row">
              <div class="festo-info-label">{{'Tracking' | translate}}</div>
              <div class="festo-info-value">
                <button class="festo-action-btn track-btn"
                        (click)="this.parent.RedirectToURLWithUrlChangeNewTab(invoice.Details.ShippingDetails.ShippingCompany.TrackingUrl);"
                        matTooltip="{{ 'Track Shipment' | translate}}"
                        matTooltipClass='neutral-tool-tip'>
                  <i class="material-icons">local_shipping</i>
                  <span>{{'Track Shipment' | translate}}</span>
                </button>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>

      <!-- Open Items Table -->
      <div *ngIf="this.Order?.Cart?.OpenItems?.length > 0" class="festo-grid-section">
        <div class="OrderProductsTablePreTitle">{{'OpenOrdersProducts' | translate}}</div>
        <div class="modern-table-container">
          <table class="modern-table ios-product-table">
            <thead>
              <tr>
                <th style="width: 45px;">#</th>
                <th style="width: 110px;">{{'Brand' | translate}}</th>
                <th>{{'Product' | translate}}</th>
                <th style="width: 100px;">{{'ETA' | translate}}</th>
                <th style="width: 60px; text-align: center;">{{'Quantity' | translate}}</th>
                <th style="width: 105px; text-align: right;">{{'Price' | translate}}</th>
                <th style="width: 105px; text-align: right;">{{'Total' | translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of this.Order?.Cart?.OpenItems;" [ngClass]="{'status-canceled': item.ProgressStatus?.ID === -1, 'status-ready': item.ProgressStatus?.ID === 2, 'status-sent': item.ProgressStatus?.ID === 3}">
                <td class="text-center">{{item.position}}</td>
                <td><strong>{{item.Product?.Brand?.Name}}</strong></td>
                <td>
                  <div class="product-info">
                    <div class="product-name">{{item.Product?.Name}}</div>
                    <div class="product-details">
                      <span *ngIf="item.Product?.PartNumber" class="detail-item"><span class="detail-label">PN:</span> {{item.Product.PartNumber}}</span>
                      <span *ngIf="item.Product?.Stats?.HSCode" class="detail-item"><span class="detail-label">HS:</span> {{item.Product.Stats.HSCode}}</span>
                      <span *ngIf="item.Product?.Stats?.COO?.Name" class="detail-item"><span class="detail-label">COO:</span> {{item.Product.Stats.COO.ShortName}}</span>
                      <span *ngIf="item.Product?.Stats?.Weight != null" class="detail-item"><span class="detail-label">W:</span> {{item.Product.Stats.Weight}} {{item.Product.Stats.WeightMeasurementType?.Name}}</span>
                    </div>
                  </div>
                </td>
                <td>
                  <span class="ios-eta-text" *ngIf="item.SelectedOffer?.LeadTime?.ETAUI">{{item.SelectedOffer.LeadTime.ETAUI}}</span>
                  <span class="ios-eta-text" *ngIf="!item.SelectedOffer?.LeadTime?.ETAUI && item.SelectedOffer?.LeadTime?.UIOutput" style="font-size: 10px; color: #888;">{{item.SelectedOffer.LeadTime.UIOutput}}</span>
                  <span class="ios-eta-text ios-eta-empty" *ngIf="!item.SelectedOffer?.LeadTime?.ETAUI && !item.SelectedOffer?.LeadTime?.UIOutput">------</span>
                </td>
                <td class="text-center"><strong>{{item.Quantity}}</strong></td>
                <td class="text-right">{{item.Price?.UIUnitPrice}} {{item.Price?.Currency?.Name || item.CartItemOrderInfo?.OrderCurrency?.Name || item.SelectedOffer?.Currency?.Name}}</td>
                <td class="text-right"><strong class="ios-total-cell">{{item.Price?.UIQtyPrice}} {{item.Price?.Currency?.Name || item.CartItemOrderInfo?.OrderCurrency?.Name || item.SelectedOffer?.Currency?.Name}}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="order-grid-total">
          <span class="order-grid-total-label">{{'Total' | translate}}:</span>
          <span class="order-grid-total-value">{{getOpenItemsTotal()}}</span>
        </div>
      </div>

      <!-- Ready Items Table -->
      <div *ngIf="this.Order?.Cart?.ReadyItems?.length > 0" class="festo-grid-section">
        <div class="OrderProductsTablePreTitle">{{'ReadyInWarehouseOrdersProducts' | translate}}</div>
        <div class="modern-table-container">
          <table class="modern-table ios-product-table">
            <thead>
              <tr>
                <th style="width: 45px;">#</th>
                <th style="width: 110px;">{{'Brand' | translate}}</th>
                <th>{{'Product' | translate}}</th>
                <th style="width: 100px; text-align: center;">{{'ETA' | translate}}</th>
                <th style="width: 60px; text-align: center;">{{'Quantity' | translate}}</th>
                <th style="width: 105px; text-align: right;">{{'Price' | translate}}</th>
                <th style="width: 105px; text-align: right;">{{'Total' | translate}}</th>
                <th style="width: 100px; text-align: center;">{{'Invoice' | translate}}</th>
                <th style="width: 160px;">{{'Tracking' | translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of this.Order?.Cart?.ReadyItems;" [ngClass]="{'status-canceled': item.ProgressStatus?.ID === -1, 'status-ready': item.ProgressStatus?.ID === 2, 'status-sent': item.ProgressStatus?.ID === 3}">
                <td class="text-center">{{item.position}}</td>
                <td><strong>{{item.Product?.Brand?.Name}}</strong></td>
                <td>
                  <div class="product-info">
                    <div class="product-name">{{item.Product?.Name}}</div>
                    <div class="product-details">
                      <span *ngIf="item.Product?.PartNumber" class="detail-item"><span class="detail-label">PN:</span> {{item.Product.PartNumber}}</span>
                      <span *ngIf="item.Product?.Stats?.HSCode" class="detail-item"><span class="detail-label">HS:</span> {{item.Product.Stats.HSCode}}</span>
                      <span *ngIf="item.Product?.Stats?.COO?.Name" class="detail-item"><span class="detail-label">COO:</span> {{item.Product.Stats.COO.ShortName}}</span>
                      <span *ngIf="item.Product?.Stats?.Weight != null" class="detail-item"><span class="detail-label">W:</span> {{item.Product.Stats.Weight}} {{item.Product.Stats.WeightMeasurementType?.Name}}</span>
                    </div>
                  </div>
                </td>
                <td class="text-center"><i class="material-icons" style="color: #32aa3a; font-size: 18px;">check_circle</i></td>
                <td class="text-center"><strong>{{item.Quantity}}</strong></td>
                <td class="text-right">{{item.Price?.UIUnitPrice}} {{item.Price?.Currency?.Name || item.CartItemOrderInfo?.OrderCurrency?.Name || item.SelectedOffer?.Currency?.Name}}</td>
                <td class="text-right"><strong class="ios-total-cell">{{item.Price?.UIQtyPrice}} {{item.Price?.Currency?.Name || item.CartItemOrderInfo?.OrderCurrency?.Name || item.SelectedOffer?.Currency?.Name}}</strong></td>
                <td class="text-center">
                  <button *ngIf="item.CartItemOrderInfo?.Invoice?.AccountingNumber?.DisplayValue" class="festo-action-btn print-btn" (click)="GetInvoiceByAccountingDisplayValue(item.CartItemOrderInfo.Invoice)">
                    <i class="material-icons">print</i> {{item.CartItemOrderInfo?.Invoice?.AccountingNumber?.DisplayValue}}
                  </button>
                </td>
                <td>
                  <button *ngIf="item.CartItemOrderInfo?.Invoice?.Details?.ShippingDetails?.ShippingCompany?.HasTrackingURL && !item.CartItemOrderInfo?.Invoice?.IsDocumentOld"
                          class="festo-action-btn"
                          [ngClass]="{'track-btn-express': item.CartItemOrderInfo?.Invoice?.Details?.ShippingDetails?.ShippingServiceType?.ID === 1, 'track-btn': item.CartItemOrderInfo?.Invoice?.Details?.ShippingDetails?.ShippingServiceType?.ID !== 1}"
                          (click)="openTrackingUrl(item.CartItemOrderInfo.Invoice.Details.ShippingDetails.ShippingCompany.TrackingUrl)"
                          matTooltip="{{'TrackShipment' | translate}}"
                          matTooltipClass='neutral-tool-tip'>
                    <i class="material-icons">{{item.CartItemOrderInfo?.Invoice?.Details?.ShippingDetails?.ShippingServiceType?.ID === 1 ? 'flight' : 'local_shipping'}}</i>
                    {{item.CartItemOrderInfo?.Invoice?.Details?.ShippingDetails?.ShippingCompany?.Name}} {{item.CartItemOrderInfo?.Invoice?.Details?.ShippingDetails?.TrackingLabel}}
                  </button>
                  <span *ngIf="item.CartItemOrderInfo?.Invoice?.IsDocumentOld && item.CartItemOrderInfo?.Invoice?.Details?.ShippingDetails?.TrackingLabel" class="festo-status-badge" style="background: rgba(142,142,147,0.12); color: #8e8e93; font-size: 9px; cursor: help;"
                        matTooltip="{{'TrackingOlderThan6MonthsDisclaimer' | translate}}" matTooltipClass='neutral-tool-tip'>
                    {{item.CartItemOrderInfo?.Invoice?.Details?.ShippingDetails?.ShippingCompany?.Name}} {{item.CartItemOrderInfo?.Invoice?.Details?.ShippingDetails?.TrackingLabel}}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="order-grid-total">
          <span class="order-grid-total-label">{{'Total' | translate}}:</span>
          <span class="order-grid-total-value">{{getReadyItemsTotal()}}</span>
        </div>
      </div>

      <!-- Delivered Items Table -->
      <div *ngIf="this.Order?.Cart?.DeliveredItems?.length > 0" class="festo-grid-section">
        <div class="OrderProductsTablePreTitle">{{'DeliveredOrdersProducts' | translate}}</div>
        <div class="modern-table-container">
          <table class="modern-table ios-product-table">
            <thead>
              <tr>
                <th style="width: 45px;">#</th>
                <th style="width: 110px;">{{'Brand' | translate}}</th>
                <th>{{'Product' | translate}}</th>
                <th style="width: 100px; text-align: center;">{{'ETA' | translate}}</th>
                <th style="width: 60px; text-align: center;">{{'Quantity' | translate}}</th>
                <th style="width: 105px; text-align: right;">{{'Price' | translate}}</th>
                <th style="width: 105px; text-align: right;">{{'Total' | translate}}</th>
                <th style="width: 100px; text-align: center;">{{'Invoice' | translate}}</th>
                <th style="width: 160px;">{{'Tracking' | translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of this.Order?.Cart?.DeliveredItems;" [ngClass]="{'status-canceled': item.ProgressStatus?.ID === -1, 'status-ready': item.ProgressStatus?.ID === 2, 'status-sent': item.ProgressStatus?.ID === 3}">
                <td class="text-center"><i class="material-icons delivered-check-icon">verified</i></td>
                <td><strong>{{item.Product?.Brand?.Name}}</strong></td>
                <td>
                  <div class="product-info">
                    <div class="product-name">{{item.Product?.Name}}</div>
                    <div class="product-details">
                      <span *ngIf="item.Product?.PartNumber" class="detail-item"><span class="detail-label">PN:</span> {{item.Product.PartNumber}}</span>
                      <span *ngIf="item.Product?.Stats?.HSCode" class="detail-item"><span class="detail-label">HS:</span> {{item.Product.Stats.HSCode}}</span>
                      <span *ngIf="item.Product?.Stats?.COO?.Name" class="detail-item"><span class="detail-label">COO:</span> {{item.Product.Stats.COO.ShortName}}</span>
                      <span *ngIf="item.Product?.Stats?.Weight != null" class="detail-item"><span class="detail-label">W:</span> {{item.Product.Stats.Weight}} {{item.Product.Stats.WeightMeasurementType?.Name}}</span>
                    </div>
                  </div>
                </td>
                <td class="text-center"><i class="material-icons" style="color: #32aa3a; font-size: 18px;">check_circle</i></td>
                <td class="text-center"><strong>{{item.Quantity}}</strong></td>
                <td class="text-right">{{item.Price?.UIUnitPrice}} {{item.Price?.Currency?.Name || item.CartItemOrderInfo?.OrderCurrency?.Name || item.SelectedOffer?.Currency?.Name}}</td>
                <td class="text-right"><strong class="ios-total-cell">{{item.Price?.UIQtyPrice}} {{item.Price?.Currency?.Name || item.CartItemOrderInfo?.OrderCurrency?.Name || item.SelectedOffer?.Currency?.Name}}</strong></td>
                <td class="text-center">
                  <button *ngIf="item.CartItemOrderInfo?.Invoice?.AccountingNumber?.DisplayValue" class="festo-action-btn print-btn" (click)="GetInvoiceByAccountingDisplayValue(item.CartItemOrderInfo.Invoice)">
                    <i class="material-icons">print</i> {{item.CartItemOrderInfo?.Invoice?.AccountingNumber?.DisplayValue}}
                  </button>
                </td>
                <td>
                  <button *ngIf="item.CartItemOrderInfo?.Invoice?.Details?.ShippingDetails?.ShippingCompany?.HasTrackingURL && !item.CartItemOrderInfo?.Invoice?.IsDocumentOld"
                          class="festo-action-btn"
                          [ngClass]="{'track-btn-express': item.CartItemOrderInfo?.Invoice?.Details?.ShippingDetails?.ShippingServiceType?.ID === 1, 'track-btn': item.CartItemOrderInfo?.Invoice?.Details?.ShippingDetails?.ShippingServiceType?.ID !== 1}"
                          (click)="openTrackingUrl(item.CartItemOrderInfo.Invoice.Details.ShippingDetails.ShippingCompany.TrackingUrl)"
                          matTooltip="{{'TrackShipment' | translate}}"
                          matTooltipClass='neutral-tool-tip'>
                    <i class="material-icons">{{item.CartItemOrderInfo?.Invoice?.Details?.ShippingDetails?.ShippingServiceType?.ID === 1 ? 'flight' : 'local_shipping'}}</i>
                    {{item.CartItemOrderInfo?.Invoice?.Details?.ShippingDetails?.ShippingCompany?.Name}} {{item.CartItemOrderInfo?.Invoice?.Details?.ShippingDetails?.TrackingLabel}}
                  </button>
                  <span *ngIf="item.CartItemOrderInfo?.Invoice?.IsDocumentOld && item.CartItemOrderInfo?.Invoice?.Details?.ShippingDetails?.TrackingLabel" class="festo-status-badge" style="background: rgba(142,142,147,0.12); color: #8e8e93; font-size: 9px; cursor: help;"
                        matTooltip="{{'TrackingOlderThan6MonthsDisclaimer' | translate}}" matTooltipClass='neutral-tool-tip'>
                    {{item.CartItemOrderInfo?.Invoice?.Details?.ShippingDetails?.ShippingCompany?.Name}} {{item.CartItemOrderInfo?.Invoice?.Details?.ShippingDetails?.TrackingLabel}}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="order-grid-total">
          <span class="order-grid-total-label">{{'Total' | translate}}:</span>
          <span class="order-grid-total-value">{{getDeliveredItemsTotal()}}</span>
        </div>
      </div>


    </div>
</div>
